import ReactDOM             from 'react-dom';
import { Provider }         from 'react-redux';
import React, { Component } from 'react';
import { Route, Switch }    from 'react-router-dom';
import { ConnectedRouter }  from 'react-router-redux';
import { OidcProvider }     from 'redux-oidc';

import { history, createTheStore }  from './store/store';
import App                          from './components/App';
import { userManagerPromise }       from './oidc/userManager';

class AppInitializer extends Component {
    state = {
        store: null,
        userManager: null,
        loading: true,
    };

    componentDidMount() {
        try {
            createTheStore().then(store => {
                userManagerPromise.then(userManager =>{
                    this.setState({
                        store,
                        userManager,
                        loading: false,
                    });
                });
        });
        } catch (error) {
            console.error('Error during app initialization:', error);
            // You might want to show an error message or fallback UI here
        }
    }

    render() {
        const { store, userManager, loading } = this.state;

        if (loading) {
            return <div>Loading...</div>; // Show a loading indicator until initialization is complete
        }

        return (
            <Provider store={store}>
                <OidcProvider store={store} userManager={userManager}>
                    <ConnectedRouter history={history} onUpdate={() => window.scrollTo(0, 0)}>
                        <Switch>
                            <Route path="/" component={App} />
                        </Switch>
                    </ConnectedRouter>
                </OidcProvider>
            </Provider>
        );
    }
}

ReactDOM.render(<AppInitializer />, document.getElementById('root'));



// WEBPACK FOOTER //
// /src/index.js